import { WidgetWrapper, WidgetProps } from '~/widgets/shared'
import { TariffCalculatorInner } from '~/widgets/TariffCalculator/TariffCalculatorInner'

interface TariffCalculatorProps extends WidgetProps {
  title?: string
}

export function TariffCalculator({
  title: _title = 'Tariff Calculator',
  ...wrapperProps
}: TariffCalculatorProps) {
  return (
    <WidgetWrapper {...wrapperProps}>
      <TariffCalculatorInner />
    </WidgetWrapper>
  )
}
